/**
 * Opens a hidden print window, writes a self-contained HTML document into it
 * and triggers the browser print dialog. Used as the fallback when no printer
 * device is assigned in Settings → Devices, or when direct printing fails.
 *
 * Returns `false` when the pop-up was blocked so callers can surface a hint.
 */
export function openPrintWindow(html: string): boolean {
  const printWindow = window.open('', '_blank', 'width=900,height=800');
  if (!printWindow) return false;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.onafterprint = () => printWindow.close();

  // Give the document a moment to lay out before invoking print.
  setTimeout(() => {
    printWindow.focus();
    printWindow.print();
  }, 350);

  return true;
}
